// extracted by mini-css-extract-plugin
module.exports = {"form-controls__wrapper":"modal-edit-or-create-item_form-controls__wrapper___s78B"};